//import React from 'react';
import ReactDOM from 'react-dom';
import './main.css';

import Abacus from './abacus';
import Soroban from './soroban';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(Abacus, document.getElementById('abacus'));
ReactDOM.render(Soroban, document.getElementById('soroban'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js